import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import TopBar from "../components/layout/TopBar";
import FooterBar from "../components/layout/FooterBar";
import "../pages/landing/LandingPageNew.css";
import "../pages/auth/whatsapp-auth.css";

const { Content } = Layout;

const AuthLayout = () => {
  const { currentUser } = React.useContext(AuthContext);
  const [theme, setTheme] = useState(() => {
    return "light";
  });

  // Apply theme on mount and change
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="auth-layout" data-theme={theme}>
      <TopBar theme={theme} toggleTheme={toggleTheme} />
      <Layout style={{ minHeight: '100vh', background: 'transparent' }}>
        <Content style={{ paddingTop: '76px' }}>
          <Outlet context={{ theme, toggleTheme }} />
        </Content>
        <FooterBar theme={theme} />
      </Layout>
    </div>
  );
};

export default AuthLayout;
